import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=3dc0595e&scoped=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=ts"
export * from "./GlobalLoader.vue?vue&type=script&lang=ts"
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=3dc0595e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0595e",
  null
  
)

export default component.exports